import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import i18n from "src/i18n"
import { playerFacingError } from "src/utils/errorMessages"
import { addMessage } from "src/store/messages"

import userReducers from "../reducers"

/* Attaching Google to the account you are already signed in to (2026-08-21, copied in shape from
   the supermanager frontend). The credential is the same one-string handoff sign-in uses; only the
   endpoint differs, and the answer is the user, not a token pair — this is a change to an account,
   not a way into one. */
export const thunk = createAsyncThunk("user/linkGoogle", async (credential, { dispatch, rejectWithValue }) => {
  try {
    const response = await apiClient.post("/auth/google/link/", { credential })
    dispatch(addMessage({ text: i18n.t("settings.googleLinked"), type: "success" }))
    return {
      googleLinked: response.data.google_linked,
      googleEmail: response.data.google_email ?? null,
      hasPassword: response.data.has_password,
      email: response.data.email,
    }
  } catch (error) {
    const detail = error.response?.data?.detail
    dispatch(addMessage({ text: detail || playerFacingError(error.response?.data), type: "error" }))
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = userReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
